module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/babel-runtime/core-js/object/assign.js
// module id = 696
// module chunks = 0